import { render, staticRenderFns } from "./contract-prop-label.vue?vue&type=template&id=c5d11a54"
import script from "./contract-prop-label.vue?vue&type=script&lang=js"
export * from "./contract-prop-label.vue?vue&type=script&lang=js"
import style0 from "./contract-prop-label.vue?vue&type=style&index=0&id=c5d11a54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports